import { MAX_INPUT_ROWS } from '../constants';

export const transformStringToArrayByNewLine = (str: string) =>
  Array.from(
    new Set(
      str
        .trim()
        .split('\n')
        .filter((str) => str)
        .map((str) => str.trim()),
    ),
  );

export const transformArrayToStringValue = (arr: Array<string> | undefined) => (arr ? arr.join('\n') : '');

export const getInputRowsCount = (str: string) => {
  const textareaRows = str.split('\n').length;
  return textareaRows > MAX_INPUT_ROWS ? MAX_INPUT_ROWS : textareaRows;
};
